import {  Container,  makeStyles, Typography } from "@material-ui/core";



const useStyles = makeStyles({
    container: {
        height: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "20px",
        paddingTop: "50px"
    }
})

export default function Error(props) {
    let classes = useStyles();
    return (
        <Container  fixed className={classes.container}>
            <Typography variant="h4">
                Error
            </Typography>
            <Typography variant="caption">
                {props.error}
            </Typography>
        </Container>
    )
}